// to be used with HU_TAX_NUMBER InputMask
export class HuTaxNumber {
  private _raw: string = '';

  static getPattern(): RegExp {
    return /^(\d{7})(\d)(-[1-5])?(-(0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51))?$/;
  }

  static validate(taxNumber: string): boolean {
    let pattern = HuTaxNumber.getPattern();
    const matches = taxNumber.match(pattern);
    if (matches) {
      // Szorzók az adószám törzsszám része (első 8 jegy) ellenőrző számjegyének
      // meghatározásához (a 8. jegy az első hét jegy alapján). Az adott szorzóval, a
      // törzsszám megfelelő számjegyét (elölről indulva) megszorozzuk, majd ezen
      // szorzatok összegét képezzük.
      const mul = [9, 7, 3, 1, 9, 7, 3];
      // Az adószám törzsszám részének első 7 jegye.
      const base = matches[1].split("");
      // Ellenőrző számjegy (az adószám 8. jegye).
      const check = parseInt(matches[2]);
      // Ellenőrző összeg meghatározása.
      let sum = 0;
      for (let i = 0; i < 7; i++) {
        sum += parseInt(base[i]) * mul[i];
      }
      // Az ellenőrző összeg utolsó jegyének meghatározása (= 10-zel való osztás maradéka).
      let last = sum % 10;
      // Ha a kiszámított ellenőrző számjegy nem nulla, akkor 10-ből kivonjuk.
      if (last > 0) {
        last = 10 - last;
      }
      // A kiszámított és kapott ellenőrző számjegyek egyezősége alapján
      // lesz helyes vagy helytelen az adószám.
      return last === check;
    }
    return false;
  }

  set raw(raw: string) {
    this._raw = raw;
  }

  get raw(): string {
    return this._raw;
  }

  get truncated(): string | undefined {
    if (this._raw === '') {
      return undefined;
    }
    let temp = this._raw;
    while (!temp.charAt(temp.length - 1).match('[0-9]')) {
      temp = temp.substring(0, temp.length - 1);
    }
    return temp;
  }
}

export class EuVatNumber {
  private _raw: string = '';

  static getPattern(): RegExp {
    return new RegExp('^[A-Z]{2}[A-Z0-9]{2,13}$');
  }

  set raw(raw: string) {
    this._raw = raw;
  }

  get raw(): string {
    return this._raw;
  }

  get truncated(): string | undefined {
    if (this._raw === '') {
      return undefined;
    }
    let temp = this._raw;
    while (!temp.charAt(temp.length - 1).match('[0-9,A-Z]')) {
      temp = temp.substring(0, temp.length - 1);
    }
    return temp;
  }
}
